/**
 * Studio package definitions — slot sizes, counts, and funnel copy.
 * Keyed by Shopify page handle (e.g. gravity-start-2 = Gravity Advance M).
 */
window.GRAVITY_PACKAGES = {
  'gravity-start': {
    name: 'Gravity Start',
    priceLabel: '880€',
    packagePriceCents: 88000,
    discountCode: 'PKG-GRAVITY-START',
    discountEuro: 420,
    compareLabel: '€1,300',
    savingsLabel: 'YOU SAVE 420€',
    slots: [
      { size: 'XS', label: 'XS backdrop 1', dims: '1.2 × 2.4m' },
      { size: 'XS', label: 'XS backdrop 2', dims: '1.2 × 2.4m' },
      { size: 'XS', label: 'XS backdrop 3', dims: '1.2 × 2.4m' },
      { size: 'XS', label: 'XS backdrop 4', dims: '1.2 × 2.4m' },
    ],
    freeXs: true,
    perks: ['4× XS hand-painted canvases', 'Free worldwide shipping', 'Free XS backdrop with qualifying purchase'],
  },
  'gravity-basic': {
    name: 'Gravity Basic',
    priceLabel: '770€',
    packagePriceCents: 77000,
    discountCode: 'PKG-GRAVITY-BASIC',
    discountEuro: 420,
    compareLabel: '€1,190',
    savingsLabel: 'YOU SAVE 420€',
    slots: [
      { size: 'Standard', label: 'Standard backdrop 1', dims: '1.6 × 2.7m' },
      { size: 'Standard', label: 'Standard backdrop 2', dims: '1.6 × 2.7m' },
      { size: 'Standard', label: 'Standard backdrop 3', dims: '1.6 × 2.7m' },
    ],
    freeXs: true,
    perks: ['3× Standard hand-painted canvases', 'Free worldwide shipping', 'Free XS backdrop with qualifying purchase'],
  },
  'gravity-start-2': {
    name: 'Gravity Advance M',
    priceLabel: '880€',
    packagePriceCents: 88000,
    discountCode: 'PKG-GRAVITY-ADVANCE-M',
    discountEuro: 550,
    compareLabel: '€1,355',
    savingsLabel: 'YOU SAVE 475€',
    slots: [
      { size: 'Mid', label: 'Mid backdrop 1', dims: '1.9 × 2.7m' },
      { size: 'Mid', label: 'Mid backdrop 2', dims: '1.9 × 2.7m' },
      { size: 'Mid', label: 'Mid backdrop 3', dims: '1.9 × 2.7m' },
    ],
    freeXs: true,
    perks: ['3× Mid hand-painted canvases', 'Free worldwide shipping', 'Free XS backdrop with qualifying purchase'],
  },
  'gravity-l': {
    name: 'Gravity Advance L',
    priceLabel: '880€',
    packagePriceCents: 88000,
    discountCode: 'PKG-GRAVITY-ADVANCE-L',
    discountEuro: 530,
    compareLabel: '€1,410',
    savingsLabel: 'YOU SAVE 530€',
    slots: [
      { size: 'Large', label: 'Large backdrop 1', dims: '2.1 × 2.7m' },
      { size: 'Large', label: 'Large backdrop 2', dims: '2.1 × 2.7m' },
      { size: 'Standard', label: 'Free Standard backdrop', dims: '1.6 × 2.7m', bonus: true },
    ],
    freeXs: true,
    perks: ['2× Large + 1 free Standard', 'Free worldwide shipping', 'Free XS backdrop with qualifying purchase'],
  },
  'gravity-profesional': {
    name: 'Gravity Professional L',
    priceLabel: '1,320€',
    packagePriceCents: 132000,
    discountCode: 'PKG-GRAVITY-PRO-L',
    discountEuro: 640,
    compareLabel: '€1,960',
    savingsLabel: 'YOU SAVE 640€',
    featured: true,
    slots: [
      { size: 'Large', label: 'Large backdrop 1', dims: '2.1 × 2.7m' },
      { size: 'Large', label: 'Large backdrop 2', dims: '2.1 × 2.7m' },
      { size: 'Large', label: 'Large backdrop 3', dims: '2.1 × 2.7m' },
      { size: 'Large', label: 'Large backdrop 4', dims: '2.1 × 2.7m' },
    ],
    freeXs: true,
    perks: ['4× Large hand-painted canvases', 'Free worldwide shipping', 'Free XS backdrop with qualifying purchase'],
  },
  'gravity-gold': {
    name: 'Gravity Gold',
    priceLabel: '935€',
    packagePriceCents: 93500,
    discountCode: 'PKG-GRAVITY-GOLD',
    discountEuro: 530,
    compareLabel: '€1,465',
    savingsLabel: 'YOU SAVE 530€',
    slots: [
      { size: 'Large', label: 'Large backdrop 1', dims: '2.1 × 2.7m' },
      { size: 'Large', label: 'Large backdrop 2', dims: '2.1 × 2.7m' },
      { size: 'Mid', label: 'Free Mid backdrop', dims: '1.9 × 2.7m', bonus: true },
    ],
    freeXs: true,
    perks: ['2× Large + 1 free Mid', 'Free worldwide shipping', 'Free XS backdrop with qualifying purchase'],
  },
  'gravity-platinum': {
    name: 'Gravity Platinum',
    priceLabel: '1,320€',
    packagePriceCents: 132000,
    discountCode: 'PKG-GRAVITY-PLATINUM',
    discountEuro: 585,
    compareLabel: '€1,905',
    savingsLabel: 'YOU SAVE 585€',
    slots: [
      { size: 'Large+', label: 'Large+ backdrop 1', dims: '2.7 × 3m' },
      { size: 'Large+', label: 'Large+ backdrop 2', dims: '2.7 × 3m' },
      { size: 'Mid', label: 'Free Mid backdrop', dims: '1.9 × 2.7m', bonus: true },
    ],
    freeXs: true,
    perks: ['2× Large+ + 1 free Mid', 'Free worldwide shipping', 'Free XS backdrop with qualifying purchase'],
  },
  'gravity-ultimate': {
    name: 'Gravity Ultimate',
    priceLabel: '1,760€',
    packagePriceCents: 176000,
    discountCode: 'PKG-GRAVITY-ULTIMATE',
    discountEuro: 200,
    compareLabel: '€1,960',
    savingsLabel: 'YOU SAVE 200€',
    slots: [
      { size: 'XL', label: 'XL backdrop 1', dims: '2.7 × 4m' },
      { size: 'XL', label: 'XL backdrop 2', dims: '2.7 × 4m' },
    ],
    freeXs: true,
    perks: ['2× XL hand-painted canvases', 'Free worldwide shipping', 'Free XS backdrop with qualifying purchase'],
  },
};
